export interface Nivel {
    id?: string,
    nombre: string,
    descripcion: string
}

export const defaultNivel = { id: '', nombre: '', descripcion: '' };